import { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { getRefreshTokenCookie } from "lib/Storage";
import FaalComponent from "components/TimelinePageOne/Screen/Faal";
import SliderComponent from "components/TimelinePageOne/Screen/Slider";
import SearchComponent from "components/TimelinePageOne/Screen/Search";
import LoginComponent from "components/TimelinePageOne/Screen/Login";
import GameBox from "components/TimelinePageOne/Screen/GameBox";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import useInputKeys from "hooks/useInputKeys";
import Settings from "./Settings";
import MenuIcon from "assets/images/menuIcon.png";
import Magnifier1 from "assets/images/Magnifier.png";
import Expelor from "assets/images/Expelor.png";
import TLMenu from "assets/images/TLMenu.png";
import FaalMenu from "assets/images/faalMenu.png";
import SettingFilled from "assets/images/SettingFilled.png";
import GameIconOff from "assets/images/gameIconOff.png";
import Lyrics from "./Lyrics";
import SliderComponentTitle from "./Slider/SliderComponentTitle";
import "./index.scss";
import GameIconComponent from "components/Shared/GameIcon";

function Screen() {
  const {
    isLoggedIn,
    activeTab,
    setActiveTab,
    setPlay,
    setCurrentTimelineId,
    currentTimeline,
    setInputType,
    sharedFaalId,
    setSharedFaalId,
    currentFrequency,
    setCurrentFrequency,
    currentTimelineIndex,
    direction,
    expand,
    setExpand,
    timelinesData,
    ownersTitle,
    frequencyData,
    activeSlideArtistName,
    setKeepPlay,
    sharedTimeline,
  } = useInputKeys();

  const [gameStatus, setGameStatus] = useState(false);
  const [lyrics, setLyrics] = useState("");
  const [redirectLogin, setRedirectLogin] = useState(false);
  const theme = useTheme();

  const widthFactor = 450;

  const handleChange = (event, newValue) => {
    if (!!sharedFaalId) {
      setSharedFaalId("");
    }
    if (newValue === "1") {
      setInputType("en");
    } else if (newValue === "2") {
      setInputType("bare");
    } else if (newValue === "3") {
      setPlay(false);
    } else if (newValue === "4") {
      window.location.href = `https://alphaplanet.tltimeline.ir/auth?t=${getRefreshTokenCookie()}`;
      // window.location.href = `http://127.0.0.1:3000/auth?t=${getRefreshTokenCookie()}`;
    }
    setActiveTab(newValue);
  };

  const handleChangeGameStatus = () => {
    setGameStatus((pre) => !pre);
  };

  const fontSize = (ownersTitle, maxFont) => {
    if (window.screen.width >= 1100) {
      return Math.min(
        maxFont,
        (widthFactor / (ownersTitle[currentFrequency]?.length * 20)) * 23
      );
    }
    if (window.screen.width >= 768) {
      return Math.min(
        maxFont,
        (widthFactor / (ownersTitle[currentFrequency]?.length * 20)) * 21
      );
    }
    if (window.screen.width >= 480) {
      return Math.min(
        maxFont,
        (widthFactor / (ownersTitle[currentFrequency]?.length * 20)) * 20
      );
    }
    if (window.screen.width < 480) {
      return Math.min(
        maxFont,
        (widthFactor / (ownersTitle[currentFrequency]?.length * 20)) * 16
      );
    }
    if (window.screen.width <= 384) {
      return Math.min(
        maxFont,
        (widthFactor / (ownersTitle[currentFrequency]?.length * 20)) * 12
      );
    }
  };

  useEffect(() => {
    if (activeTab !== "2") {
      setExpand(false);
    }
  }, [activeTab, setExpand]);

  useEffect(() => {
    if (getRefreshTokenCookie()) {
      setRedirectLogin(true);
    }
  }, [activeTab]);

  return (
    <div
      className={`screen-wrapper ${
        direction === "rtl" ? "right" : "left"
      }-arrange ${expand ? "expand" : ""}`}
    >
      {
        <Box
          sx={{
            width: "100%",
            height: "100%",
            typography: "body1",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
          className="screen-content"
        >
          {(isLoggedIn || sharedFaalId || sharedTimeline) && redirectLogin ? (
            <TabContext value={activeTab}>
              <Box sx={{ height: "100%" }}>
                <TabPanel value="1" sx={{ padding: "0" }}>
                  <SearchComponent activeSearch={activeTab === "1"} />
                </TabPanel>

                <TabPanel value="2" sx={{ padding: "0" }}>
                  {lyrics === "Lyrics" ? (
                    <Lyrics
                      currentFrequency={currentFrequency}
                      ownersTitle={ownersTitle}
                      setLyrics={setLyrics}
                      timelinesData={timelinesData}
                      currentTimelineIndex={currentTimelineIndex}
                    />
                  ) : (
                    <>
                      <div className="topBox">
                        <div className="topBoxContent">
                          <div className="frequency">{`FQ: ${currentFrequency || "-"}`}</div>
                          <div className="action-box">
                            <div className="game-button" onClick={handleChangeGameStatus}>
                              {gameStatus ? (
                                <GameIconComponent />
                              ) : (
                                <img src={GameIconOff} alt="" />
                              )}
                            </div>
                            <div
                              onClick={() => {
                                if (
                                  currentFrequency &&
                                  currentTimeline.lyricsAvailable
                                ) {
                                  setLyrics("Lyrics");
                                }
                              }}
                              style={{ cursor: "pointer", zIndex: "10" }}
                            >
                              <img
                                src={MenuIcon}
                                alt=""
                                style={{
                                  opacity: currentTimeline.lyricsAvailable
                                    ? "100%"
                                    : "50%",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="top-divider">
                        <svg
                          width="1038"
                          height="4"
                          viewBox="0 0 1038 4"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.55957 2.55957L130.18 1.70959L259.8 1.15955L519.05 0.55957L778.31 0.659546L907.93 0.949585L1037.56 1.55957L907.93 2.41956L778.31 2.95959L519.06 3.55957L259.81 3.45959L130.18 3.15955L0.55957 2.55957Z"
                            fill={theme.palette.primary.main}
                          />
                        </svg>
                      </div>
                      {gameStatus ? (
                        <div className="game-wrapper">
                          <GameBox handleClose={handleChangeGameStatus} />
                        </div>
                      ) : currentFrequency ? (
                        <div
                          className="selectedFrequencyContainer"
                          style={{
                            direction: "rtl !important",
                            zIndex: 10,
                            top: "10%",
                          }}
                        >
                          <div
                            className={`selectedFrequency active ${
                              currentFrequency ? "animate" : ""
                            }`}
                            style={{
                              fontSize: `${fontSize(ownersTitle, 45)}px`,
                            }}
                          >
                            {ownersTitle[currentFrequency]}
                          </div>
                        </div>
                      ) : (
                        <div className="parent-sliderComponent">
                          <SliderComponentTitle
                            styleSwiper={{
                              direction: "rtl !important",
                              height: "100%",
                              color: theme.palette.primary.main,
                              top: "10%",
                            }}
                            additionalCssClass={"top"}
                            maxWidth={widthFactor}
                            maxFont={45}
                            data={frequencyData}
                            defaultSlide={activeSlideArtistName}
                            onSlideAction={setCurrentFrequency}
                            slideReverseAction={() => {
                              setCurrentFrequency(0);
                            }}
                            onClickSlide={setCurrentFrequency}
                          />
                        </div>
                      )}
                      {!gameStatus && currentFrequency && (
                        <SliderComponent
                          styleSwiper={{
                            direction: "rtl",
                            // height: "20vh",
                            position: "absolute",
                            top: "30%",
                            fontFamily: "roozname !important",
                          }}
                          additionalCssClass={"bottom"}
                          slideReverseAction={() => {
                            setCurrentFrequency(0);
                          }}
                          onActiveSlideChange={setCurrentTimelineId}
                          maxWidth={400}
                          maxFont={40}
                          data={timelinesData}
                          defaultSlide={currentTimelineIndex}
                          onClickSlide={() => setKeepPlay(true)}
                        />
                      )}
                    </>
                  )}
                </TabPanel>

                <TabPanel value="3" sx={{ padding: "0" }}>
                  <FaalComponent
                    active={activeTab === "3"}
                    isSharedFaal={true}
                    sharedFaalId={sharedFaalId}
                  />
                </TabPanel>
                <TabPanel value="5" sx={{ padding: "0" }}>
                  <Settings active={activeTab === "5"} />
                </TabPanel>
              </Box>
              <svg
                width="1038"
                height="4"
                viewBox="0 0 1038 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="screen-divider"
              >
                <path
                  d="M0.55957 2.55957L130.18 1.70959L259.8 1.15955L519.05 0.55957L778.31 0.659546L907.93 0.949585L1037.56 1.55957L907.93 2.41956L778.31 2.95959L519.06 3.55957L259.81 3.45959L130.18 3.15955L0.55957 2.55957Z"
                  fill={theme.palette.primary.main}
                />
              </svg>

              <TabList
                onChange={handleChange}
                aria-label="tabs"
                sx={{ zIndex: "10" }}
              >
                <Tab
                  sx={{ justifyContent: "start", marginTop: "0.5%" }}
                  label={<img alt="" src={Magnifier1} className="TL-logo" />}
                  value="1"
                />
                <Tab
                  sx={{ justifyContent: "start", marginTop: "0.5%" }}
                  label={
                    <img src={Expelor} alt="explorer" className="TL-logo" />
                  }
                  value="2"
                />
                <Tab
                  sx={{ justifyContent: "start", marginTop: "0.5%" }}
                  label={<img src={TLMenu} alt="TL" className="TL-logo" />}
                  value="4"
                />
                <Tab
                  sx={{ justifyContent: "start", marginTop: "0.5%" }}
                  label={<img src={FaalMenu} alt="TL" className="TL-logo" />}
                  value="3"
                />
                <Tab
                  sx={{ justifyContent: "start", marginTop: "0.5%" }}
                  label={
                    <img
                      src={SettingFilled}
                      alt="Setting"
                      className="TL-logo"
                    />
                  }
                  value="5"
                />
              </TabList>
            </TabContext>
          ) : (
            <LoginComponent />
          )}
        </Box>
      }
    </div>
  );
}

export default Screen;
